import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'script-list',
  name: '剧本列表',
  icon: '剧',
  group: '业务组件',
  description: '读取剧本数据并渲染客户端剧本卡片',
  defaultProps: {
    title: '热门剧本',
    limit: 12
}
}
